import { createBrowserRouter, Navigate, RouteObject } from "react-router-dom";
import Layout from "../Layout";
import Assessments from "../pages/Assessments";
import Dashboard from "../pages/Dashboard";
import Settings from "../pages/Settings";
import Create from "../pages/CreateAssessment";
import AssessmentReport from "../pages/Reports";
import CandidateReport from "../pages/AssessmentReport";
import AuthComponent from "../components/Auth";
import ProtectedRoute from "./ProtectedRoute";

// Define protected routes
const protectedRoutes: RouteObject[] = [
  { path: "/", element: Dashboard },
  { path: "/assessments", element: Assessments },
  { path: "/settings", element: Settings },
  { path: "/edit/:assessmentId", element: Create },
  { path: "/report/:assessmentId", element: AssessmentReport },
].map((route) => ({
  ...route,
  element: <ProtectedRoute Component={route.element as React.ComponentType} />,
}));

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [...protectedRoutes],
  },
  {
    path: "/login",
    element: <ProtectedRoute Component={AuthComponent} isPublic={true} />,
  },
  {
    path: "/candidate-report/:candidateId",
    element: <CandidateReport />,
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
]);

export default router;
